import React from "react";
import { useTranslation } from "react-i18next";
import { BPEStore } from "../ProductEditorStore";
import { observer } from "mobx-react-lite";
import SimpleImageUploader from "components/SimpleImageUploader";
import useFeatureFlag from "hooks/useFeatureFlag";

const ProductImages = () => {
  const { t } = useTranslation();
  const [uploadInprogress, setUploadInProgress] = React.useState(false);
  const { isFeatureVisible } = useFeatureFlag();

  React.useEffect(() => {
    if (uploadInprogress) {
      BPEStore.setSaveValidationErrors(true);
    } else {
      BPEStore.checkSaveValidity();
    }
  }, [uploadInprogress]);

  const onRemoveImages = (id: string) => {
    BPEStore.setImagesToRemove([...BPEStore.imagesToRemove, id]);
  };

  const addToUploadImages = (files: File[]) => {
    BPEStore.setImagesToUpload(files);
  };

  if (!isFeatureVisible("product_images")) return <></>;
  return (
    <div className="py-6 border-b border-gray-200">
      <div className="text-base font-semibold mb-3 flex items-center">
        {t("productEditor.images")}
      </div>
      <div>
        <SimpleImageUploader
          name="images"
          multiple
          onChange={addToUploadImages}
          images={BPEStore.data.images}
          onRemove={onRemoveImages}
          setInProgress={setUploadInProgress}
          maxFileSize={80 * 1024 * 1024}
        />
        <div className="text-xs font-normal text-gray-500">
          {t("productEditor.imagesUploadDesc")}
        </div>
      </div>
    </div>
  );
};

export default observer(ProductImages);
